/* ==========================================================================
   COLDEST.COM — PHASE 1 CRITICAL MOBILE FIXES (JavaScript)
   Add this to: Online Store > Themes > Customize > Theme Settings > Custom JS
   Or paste into layout/theme.liquid before </body>
   Wrap in <script> tags if pasting into theme.liquid
   ========================================================================== */

(function() {
  'use strict';

  /* -------------------------------------------------------------------
     FIX #1: ATC BUTTON — Ensure clicks always reach the button
     ------------------------------------------------------------------- */
  document.addEventListener('click', function(e) {
    // If user clicked the wrapper div instead of the button, forward the click
    var wrapper = e.target.closest('.quantity-submit-row__submit.input-row');
    if (wrapper && e.target !== document.getElementById('tfc_product_btn')) {
      var btn = wrapper.querySelector('#tfc_product_btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        btn.click();
      }
    }
  }, true);

  /* -------------------------------------------------------------------
     FIX #6: CART CONFIRMATION — DISABLED 2026-05-03
     Toast was redundant with the slide-in cart drawer. Removing it also
     drops the window.fetch / XHR.send monkey-patches below for performance.
     ------------------------------------------------------------------- */
  function createCartToast() { /* no-op — disabled */ }
  function showCartToast(/* productTitle */) { /* no-op — disabled */ }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // Update all cart count elements
        var countEls = document.querySelectorAll('.cart-count, .header-cart-count, [data-cart-count], .cart-link__count');
        countEls.forEach(function(el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.style.display = '';
          }
        });
      })
      .catch(function() {});
  }

  // Intercept Add to Cart form submissions — DISABLED 2026-05-03
  // Was monkey-patching window.fetch, XMLHttpRequest.prototype.open/send and
  // submit listeners just to drive the toast. Cart drawer already opens on add
  // so all of this is dead weight — keeping a no-op stub so call sites are safe.
  function interceptATC() { /* no-op — disabled */ }

  /* -------------------------------------------------------------------
     FIX #5: CHECKOUT — Retry on failure
     If checkout fails to load, automatically retry once
     ------------------------------------------------------------------- */
  if (window.location.pathname === '/cart') {
    var checkoutBtns = document.querySelectorAll('[name="checkout"], .cart__checkout-button, button[type="submit"][value="checkout"]');
    checkoutBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        // Store a retry flag in sessionStorage (throws when storage is blocked)
        try { sessionStorage.setItem('coldest_checkout_retry', '1'); } catch (e) {}
      });
    });
  }

  // If we're on a checkout error page, retry. Guarded: storage access throws a
  // SecurityError when blocked, which would otherwise abort the init below.
  try {
    if (sessionStorage.getItem('coldest_checkout_retry') === '1') {
      if (document.title.indexOf('problem') !== -1 || document.body.textContent.indexOf('problem loading') !== -1) {
        sessionStorage.removeItem('coldest_checkout_retry');
        // Retry checkout
        window.location.href = '/checkout';
      } else {
        sessionStorage.removeItem('coldest_checkout_retry');
      }
    }
  } catch (e) {}

  /* -------------------------------------------------------------------
     INIT — Run on DOM ready
     ------------------------------------------------------------------- */
  /* -------------------------------------------------------------------
     FIX: PINCH-TO-ZOOM on PDP gallery images (mobile)
     Slick Carousel sets touch-action:manipulation inline via JS and
     calls preventDefault() on touchmove, blocking pinch zoom.
     We override the inline styles and patch touchmove handlers.
     ------------------------------------------------------------------- */
  function enablePinchZoom() {
    if (window.innerWidth > 768) return;
    var slideshow = document.querySelector('.product-slideshow, .gallery__inner');
    if (!slideshow) return;

    // Override inline touch-action styles set by Slick
    var targets = slideshow.querySelectorAll('.slick-list, .slick-track, .slick-slide, .slide, .product-media, .product-media img, .rimage__image');
    targets.forEach(function(el) {
      el.style.setProperty('touch-action', 'pan-x pan-y pinch-zoom', 'important');
    });
    slideshow.style.setProperty('touch-action', 'pan-x pan-y pinch-zoom', 'important');

    // Intercept touchmove: if 2+ fingers (pinch), don't let Slick block it
    slideshow.addEventListener('touchmove', function(e) {
      if (e.touches && e.touches.length >= 2) {
        e.stopPropagation();
      }
    }, { passive: true, capture: true });
  }

  /* -------------------------------------------------------------------
     Removed (Request 314, 2026-11-04):
       - hideRichpanelBranding(): Richpanel's app embed is switched off, so a
         document-wide MutationObserver plus a 30 x 2s iframe scan ran on every
         page for a widget that never loads.
       - movePersonalizeAboveATC() / watchForPersonalize(): Globo Product
         Options is uninstalled (Request 236 replaced it with the native
         Personalize card, which is rendered in place), so five timers and a
         30s body-subtree observer looked for .gpo-* on every PDP for nothing.
     ------------------------------------------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      /* interceptATC() and createCartToast() removed — cart drawer covers this */
      setTimeout(enablePinchZoom, 1000);
    });
  } else {
    /* interceptATC() and createCartToast() removed — cart drawer covers this */
    setTimeout(enablePinchZoom, 1000);
  }
})();
